import React from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { fetchOwnerNotifications } from '@/store/slices/ownerNotifications';

import { useFeatureGate } from '../../hooks/useFeatureGate';
import { useRefetchOnVisible } from '../../hooks/useRefetchOnVisible';

/**
 * Keeps the owner's notifications fresh, app-wide (mounted once in the layout): read for the signed-in owner on
 * load and on a token or identity change, and again when the tab comes back, since a push sent while the socket
 * was asleep is lost. New ones arrive on the websocket in between (store/ws/ws.js). Nothing is read while the
 * `owner-notifications` flag is off.
 */
export const useOwnerNotificationsSync = (): void => {
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.authentication.access_token) || '';
  const on = useFeatureGate().isEnabled('owner-notifications');

  React.useEffect(() => {
    if (token && on) void dispatch(fetchOwnerNotifications());
  }, [dispatch, token, on]);

  const reload = React.useCallback((): void => {
    void dispatch(fetchOwnerNotifications());
  }, [dispatch]);
  useRefetchOnVisible(reload, Boolean(token) && on);
};
